export default __webpack_public_path__ + "static/media/orange.b1e7bff2.png";